export var NAME = 'curie';
export var RUBRIQ_LOAD_REQUESTED = "".concat(NAME, "/RUBRIQ_LOAD_REQUESTED");
export var RUBRIQ_LOAD_COMPLETED = "".concat(NAME, "/RUBRIQ_LOAD_COMPLETED");
export var CURIE_DATA_UPDATED = 'CURIE_DATA_UPDATED';
export var RUBRIQ_SYNCED = "".concat(NAME, "/RUBRIQ_SYNCED");
export var DIGITAL_EDIT_LIMIT_REACHED_LOADED = "".concat(NAME, "/DIGITAL_EDIT_LIMIT_REACHED_LOADED");
export var ERROR_UPDATED = "".concat(NAME, "/ERROR_UPDATED");
export var PLAN_UPDATE_FLAGGED = "".concat(NAME, "/PLAN_UPDATE_FLAGGED");
export var PLAN_UPDATE_SYNCED = "".concat(NAME, "/PLAN_UPDATE_SYNCED");
export var PLAN_UPDATE_COMPLETED = "".concat(NAME, "/PLAN_UPDATE_COMPLETED");
export var CLEAR_RUBRIQ_PLAN = "".concat(NAME, "/CLEAR_RUBRIQ_PLAN");
export var TRANSITION_MODAL_CLEARED = "".concat(NAME, "/TRANSITION_MODAL_CLEARED");
export var CANCEL_RUBRIQ_PLAN = "".concat(NAME, "/CANCEL_RUBRIQ_PLAN");
export var CRITERIA_WIZARD_SESSION_STARTED = "".concat(NAME, "/CRITERIA_WIZARD_SESSION_STARTED");
export var CRITERIA_WIZARD_SESSION_LOADED = "".concat(NAME, "/CRITERIA_WIZARD_SESSION_LOADED");
export var CRITERIA_WIZARD_SESSION_SAVED = "".concat(NAME, "/CRITERIA_WIZARD_SESSION_SAVED");
export var TEMPLATE_RESPONSE_SAVED = "".concat(NAME, "/TEMPLATE_RESPONSE_SAVED");
export var SESSION_SAVED = "".concat(NAME, "/SESSION_SAVED");
export var ABSTRACT_SEARCH_REQUESTED = "".concat(NAME, "/ABSTRACT_SEARCH_REQUESTED");
export var ABSTRACT_SEARCH_COMPLETED = "".concat(NAME, "/ABSTRACT_SEARCH_COMPLETED");
export var PADDLE_INVOICES_LOADED = "".concat(NAME, "/PADDLE_INVOICES_LOADED");
export var PADDLE_FAPIAO_CANCELLED = "".concat(NAME, "/PADDLE_FAPIAO_CANCELLED");
export var PLAGIARISM_PAYMENT_SYNCED = "".concat(NAME, "/PLAGIARISM_PAYMENT_SYNCED");
export var PLAGIARISM_PLAN_UPDATE_SYNCED = "".concat(NAME, "/PLAGIARISM_PLAN_UPDATE_SYNCED");
export var START_SUBSCRIPTION_TODAY = "".concat(NAME, "/START_SUBSCRIPTION_TODAY");
export var PLAGIARISM_POLLING = {
  INTERVAL: 3000,
  ERROR_RETRY: 5000,
  MAX_RETRIES: 20
};
export var PLAGIARISM_ACTION_TYPES = {
  PLAN_UPDATE_SYNCED: 'PLAGIARISM_PLAN_UPDATE_SYNCED',
  PAYMENT_SYNCED: 'PLAGIARISM_PAYMENT_SYNCED'
};
export var PADDLE_PLAN_TYPES = {
  YEARLY: 'yearly',
  MONTHLY: 'monthly'
};
export var PLAN_EXPIRATION = {
  REMAINING_THRESHOLD: 21
};
export var RUBRIQ_DIGITAL_EDITING_ERRORS = {
  HOURLY_LIMIT_EXCEEDED: {
    title: 'hourly-limit-exceeded-title',
    content: 'hourly-limit-exceeded-content',
    primaryBtnText: 'got-it'
  },
  NO_PLAN: {
    title: 'no-plan-title',
    content: 'no-plan-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  NUMBER_OF_EDITS_EXCEEDED: {
    title: 'number-of-edits-exceeded-title',
    content: 'number-of-edits-exceeded-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  PREFERRED_GROUP_LIMIT_EXCEEDED: {
    title: 'preferred-group-limit-exceeded-title',
    content: 'preferred-group-limit-exceeded-content',
    primaryBtnText: 'got-it'
  },
  STARTER_PLAN_ENDED: {
    title: 'starter-plan-ended-title',
    content: 'starter-plan-ended-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  PREFERRED_GROUP_GENERIC_ERROR: {
    title: 'error',
    content: 'preferred-group-join-generic-error',
    primaryBtnText: 'got-it'
  },
  UNKNOWN_ERROR: {
    title: 'unknown-error-title',
    content: 'unknown-error-content',
    primaryBtnText: 'got-it'
  },
  WORD_COUNT_EXCEEDED: {
    title: 'word-count-exceeded-editing-title',
    content: 'word-count-exceeded-editing-content',
    primaryBtnText: 'got-it'
  },
  PREFERRED_GROUP_DISABLED_ERROR: {
    title: 'preferred-group-disabled-title',
    content: 'digital-access-not-available-preferred-group-disabled',
    primaryBtnText: 'got-it'
  }
};
export var RUBRIQ_DIGITAL_TRANSLATION_ERRORS = {
  NO_PLAN: {
    title: 'no-plan-translation-title',
    content: 'no-plan-translation-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  /*
    TODO: remove the "content" term below from POEditor when WRT-747 gets to production (this commented block can then be removed as well)
     NUMBER_OF_TRANSLATIONS_EXCEEDED: (contentParams) => ({
      title: 'number-of-translations-exceeded-title',
      content: 'number-of-translations-exceeded-content',
      contentParams,
      primaryBtnText: 'got-it',
  }),
  */
  NUMBER_OF_PREMIUM_AND_PREFERRED_GROUP_TRANSLATIONS_EXCEEDED: function NUMBER_OF_PREMIUM_AND_PREFERRED_GROUP_TRANSLATIONS_EXCEEDED(contentParams) {
    return {
      title: 'number-of-translations-exceeded-title',
      content: 'number-of-premium-and-preferred-group-translations-exceeded-content',
      contentParams: contentParams,
      primaryBtnText: 'got-it'
    };
  },
  NUMBER_OF_PREMIUM_TRANSLATIONS_EXCEEDED: function NUMBER_OF_PREMIUM_TRANSLATIONS_EXCEEDED(contentParams) {
    return {
      title: 'number-of-translations-exceeded-title',
      content: 'number-of-premium-translations-exceeded-content',
      contentParams: contentParams,
      primaryBtnText: 'got-it'
    };
  },
  NUMBER_OF_PREFERRED_GROUP_TRANSLATIONS_EXCEEDED: {
    title: 'number-of-translations-exceeded-title',
    content: 'number-of-preferred-group-translations-exceeded-content',
    primaryBtnText: 'got-it'
  },
  STARTER_PLAN_NO_TRANSLATIONS: {
    title: 'starter-plan-no-translations-title',
    content: 'starter-plan-no-translations-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  UNKNOWN_ERROR: {
    title: 'unknown-error-title',
    content: 'unknown-error-translation-content',
    primaryBtnText: 'got-it'
  },
  PREFERRED_GROUP_DISABLED_ERROR: {
    title: 'preferred-group-disabled-title',
    content: 'digital-access-not-available-preferred-group-disabled',
    primaryBtnText: 'got-it'
  },
  WORD_COUNT_EXCEEDED: {
    title: 'word-count-exceeded-translations-title',
    content: 'word-count-exceeded-translations-content',
    primaryBtnText: 'got-it'
  },
  EDITING_ONLY_PLAN_NO_TRANSLATIONS: {
    title: 'starter-plan-no-translations-title',
    content: 'paid-subscription-translations-not-available-content',
    primaryBtnText: 'got-it'
  },
  PAID_TRANSLATIONS_AVAILABILITY_DATE: function PAID_TRANSLATIONS_AVAILABILITY_DATE(contentParams) {
    return {
      title: 'starter-plan-no-translations-title',
      content: 'paid-subscription-translations-available-date-content',
      contentParams: contentParams,
      primaryBtnText: 'got-it'
    };
  },
  CANCELLED_PLAN_NO_TRANSLATIONS: function CANCELLED_PLAN_NO_TRANSLATIONS(contentParams) {
    return {
      title: 'no-plan-translation-title',
      content: 'cancelled-plan-no-translations-content',
      contentParams: contentParams,
      primaryBtnText: 'got-it'
    };
  }
};
export var RUBRIQ_PLAGIARISM_ERRORS = {
  HOURLY_LIMIT_EXCEEDED: {
    title: 'hourly-limit-exceeded-title',
    content: 'hourly-limit-exceeded-content',
    primaryBtnText: 'got-it'
  },
  NO_PLAN: {
    title: 'no-plan-title',
    content: 'no-plan-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  NUMBER_OF_EDITS_EXCEEDED: {
    title: 'number-of-edits-exceeded-title',
    content: 'number-of-edits-exceeded-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  PREFERRED_GROUP_LIMIT_EXCEEDED: {
    title: 'preferred-group-limit-exceeded-title',
    content: 'preferred-group-limit-exceeded-content',
    primaryBtnText: 'got-it'
  },
  STARTER_PLAN_ENDED: {
    title: 'starter-plan-ended-title',
    content: 'starter-plan-ended-content',
    secondaryBtnText: 'dismiss',
    primaryBtnText: 'upgrade-now'
  },
  PREFERRED_GROUP_GENERIC_ERROR: {
    title: 'error',
    content: 'preferred-group-join-generic-error',
    primaryBtnText: 'got-it'
  },
  UNKNOWN_ERROR: {
    title: 'unknown-error-title',
    content: 'unknown-error-content',
    primaryBtnText: 'got-it'
  },
  WORD_COUNT_EXCEEDED: {
    title: 'word-count-exceeded-editing-title',
    content: 'word-count-exceeded-editing-content',
    primaryBtnText: 'got-it'
  }
};
export var RUBRIQ_DIGITAL_EDITING_ERROR_MAP = {
  'automated-edit-not-available': RUBRIQ_DIGITAL_EDITING_ERRORS.UNKNOWN_ERROR,
  'digital-access-not-available-preferred-group-disabled': RUBRIQ_DIGITAL_EDITING_ERRORS.PREFERRED_GROUP_DISABLED_ERROR,
  'digital-editing-exceeds-max-word-count': RUBRIQ_DIGITAL_EDITING_ERRORS.WORD_COUNT_EXCEEDED,
  'digital-edit-limit-exceeded': RUBRIQ_DIGITAL_EDITING_ERRORS.UNKNOWN_ERROR,
  'maximum-automated-edits-reached': RUBRIQ_DIGITAL_EDITING_ERRORS.UNKNOWN_ERROR,
  'word-count-not-received': RUBRIQ_DIGITAL_EDITING_ERRORS.UNKNOWN_ERROR
};
export var RUBRIQ_DIGITAL_TRANSLATION_ERROR_MAP = {
  'digital-ordering-not-available': RUBRIQ_DIGITAL_TRANSLATION_ERRORS.UNKNOWN_ERROR,
  'digital-access-not-available-preferred-group-disabled': RUBRIQ_DIGITAL_TRANSLATION_ERRORS.PREFERRED_GROUP_DISABLED_ERROR,
  'digital-translations-word-count-exceeded': RUBRIQ_DIGITAL_TRANSLATION_ERRORS.WORD_COUNT_EXCEEDED,
  'file-upload-error': RUBRIQ_DIGITAL_TRANSLATION_ERRORS.UNKNOWN_ERROR,
  'word-count-not-received': RUBRIQ_DIGITAL_TRANSLATION_ERRORS.UNKNOWN_ERROR
};
export var RUBRIQ_PLAGIARISM_ERROR_MAP = {
  'automated-edit-not-available': RUBRIQ_PLAGIARISM_ERRORS.UNKNOWN_ERROR
};
export var NUMBER_OF_SECONDS_BETWEEN_PLAN_UPDATES = 3;
export var NUMBER_OF_PLAN_UPDATE_TRIES = 40;
export var NUMBER_OF_SECONDS_BETWEEN_PLAN_UPDATES_FOR_PLAGIARISM = 10;
export var NUMBER_OF_PLAN_UPDATE_TRIES_FOR_PLAGIARISM = 10;
export var HELP_CENTER_URL = 'https://customer-support.aje.com/portal/en/kb/rubriq';
export var NUMBER_OF_SECONDS_BETWEEN_DOCUMENT_CREATION_DATE_TEXT_UPDATES = 60;
export var RUBRIQ_FEATURES = {
  EDITING: 'editing',
  TRANSLATION: 'translation',
  PLAGIARISM: 'plagiarism'
};
export var RUBRIQ_DIGITAL_EDITING_UNLIMITED_USES = null;
export var RUBRIQ_FEATURE_SURVEY_THROTTLE_DAYS = 90;
export var RUBRIQ_FEATURE_SURVEY_DELAY_MS = 2000;
export var RUBRIQ_FEATURE_SURVEY_LINKS = {
  pt_BR: 'https://delighted.com/t/6CPe9f2D/v/portuguese',
  zh_CN: 'https://delighted.com/t/68IMRpsw/v/chinese',
  es_ES: 'https://delighted.com/t/NnhSA1fg/v/spanish',
  ja_JP: 'https://delighted.com/t/v7IJka6I/v/japanese',
  en_US: 'https://delighted.com/t/zTUOVGay/v/english'
};
export var RUBRIQ_ABSTRACT_TEMPLATE_ELEMENT_ICONS = {
  'Overall context': 'fa-face-thinking',
  'Specific challenge': 'fa-stairs',
  'Main result': 'fa-bullseye-pointer',
  'Main result Novelty': 'fa-list-ol',
  'Main result Context': 'fa-flag',
  Implications: 'fa-globe'
};

// TODO WRT-941 remove this when we have element coming from the database
export var RUBRIQ_ABSTRACT_TEMPLATE_QUESTION_DETAILS = {
  'What overall challenge did this work address?': {
    element: 'Overall context'
  },
  'What specific challenge did this study address?': {
    element: 'Specific challenge'
  },
  'What was the main result?': {
    element: 'Main result'
  },
  'What new information does the main result(s) add to the existing knowledge?': {
    element: 'Main result Novelty'
  },
  'What is the significance of the main result in the context of the immediate field?': {
    element: 'Main result Context'
  },
  'What impact might these results have on the broader field?': {
    element: 'Implications'
  }
};
export var STAGE_SETUP = 'setup';
export var STAGE_TEMPLATE = 'template';
export var STAGE_REVIEW = 'review';
export var ABSTRACT_WRITER_STAGEES = {
  STAGE_SETUP: STAGE_SETUP,
  STAGE_TEMPLATE: STAGE_TEMPLATE,
  STAGE_REVIEW: STAGE_REVIEW
};
export var OTP_LENGTH = 6;
export var OTP_RESEND_TIME = 60;
export var CHINA_COUNTRY_CODE = {
  value: '+86',
  phoneLength: 11
};
export var CHINA_COUNTRY = 'CN';
export var RUBRIQ_LEWIS_VERSION_MAP = {
  '1.7.0': 'rubriq.moderate-edits',
  '1.8.7': 'rubriq.high-edits'
};
export var RUBRIQ_LANGUAGE_LABELS = {
  zh_CN: 'Chinese',
  es_ES: 'Spanish',
  pt_BR: 'Português'
};
export var RUBRIQ_PLAN_NAMES_MAP = {
  premium_including_translation: 'Rubriq Premium with Translation',
  premium_editing_only: 'Rubriq Premium',
  premium_including_translation_no_trial: 'Rubriq Premium with Translation',
  premium_editing_only_no_trial: 'Rubriq Premium'
};